import { render, staticRenderFns } from "./value-summary.vue?vue&type=template&id=ef9dd5b6&scoped=true"
import script from "./value-summary.vue?vue&type=script&lang=js"
export * from "./value-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9dd5b6",
  null
  
)

export default component.exports